"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceItemType = void 0;
exports.InvoiceItemType = {
    PREP_SKU_LABELS: "PREP_SKU_LABELS",
    PREP_BAGGING: "PREP_BAGGING",
    PREP_BUBBLE_WRAPPING: "PREP_BUBBLE_WRAPPING",
    PREP_BARCODE_TRANSLATION: "PREP_BARCODE_TRANSLATION",
    PREP_BOX_BUILDING: "PREP_BOX_BUILDING",
    PREP_BOX_CONTENT_LABELS: "PREP_BOX_CONTENT_LABELS",
    PREP_FLOOR_LOADED_CONTAINER: "PREP_FLOOR_LOADED_CONTAINER",
    PREP_KITTING: "PREP_KITTING",
    PREP_QUALITY_CHECK: "PREP_QUALITY_CHECK",
    PREP_BUBBLE_MAILER: "PREP_BUBBLE_MAILER",
    PREP_CUSTOM_SKU_LABEL: "PREP_CUSTOM_SKU_LABEL",
    PREP_CARTON_LABEL: "PREP_CARTON_LABEL",
    PREP_PALLET_LABEL: "PREP_PALLET_LABEL",
    PREP_BAGGING_PROTECTION: "PREP_BAGGING_PROTECTION",
    PREP_DAMAGE_PROTECTION: "PREP_DAMAGE_PROTECTION",
    PREP_FBA_UNIT: "PREP_FBA_UNIT",
    PREP_B2B_UNIT: "PREP_B2B_UNIT",
    PREP_BAGGING_PROTECTION_RS: "PREP_BAGGING_PROTECTION_RS",
    PREP_DAMAGE_PROTECTION_RS: "PREP_DAMAGE_PROTECTION_RS",
    PREP_SKU_LABELS_RS: "PREP_SKU_LABELS_RS",
};
//# sourceMappingURL=invoice-item-type.js.map